module.exports = __webpack_public_path__ + "static/media/krx-past.45f3e974.jpg";